module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl2-50.859ca5d4.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/attack-bomber-squadrons-lvl2-50.png
// module id = 3509
// module chunks = 11